"use client";

const ContentCard = ({ title, content }) => {
  return (
    <div className="relative w-full">
<div className="relative w-full sm:w-[500px] h-[550px] sm:h-[450px] rounded-3xl border-[#e1c780] bg-neutral-700 border-[3px] p-6 transition-[background,border,border-radius,box-shadow,transform] duration-300 ease-in-out z-[1]">        <div>
          {title && (
            <p className="mb-6 text-xl text-white">
              <span className="inline underline">
                <strong className="font-bold">{title}</strong>
              </span>
            </p>
          )}
          {content.map((item, index) => (
            <p key={index} className="mb-4 text-base text-neutral-200">
              {typeof item === "string" ? (
                item
              ) : (
                <>
                  {item.text && <span>{item.text}</span>}
                  {item.break && <br className="inline" />}
                  {item.strong && (
                    <strong className="inline font-bold">
                      {item.strong}
                    </strong>
                  )}
                  {item.underline && (
                    <span className="inline underline">
                      <strong className="inline font-bold">
                        {item.underline}
                      </strong>
                    </span>
                  )}
                </>
              )}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContentCard;
